import React, { useState, useEffect, useContext } from "react";

import { makeStyles, useTheme } from "@material-ui/core/styles";
import {
  Box,
  Button,
  CircularProgress,
  Dialog,
  DialogTitle,
  Divider,
  Grid,
  Grow,
  IconButton,
  OutlinedInput,
  Tab,
  Tabs,
  TextField,
  Tooltip,
  Typography,
} from "@material-ui/core";

import { useLocation, useHistory } from "react-router-dom";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableContainer from "@material-ui/core/TableContainer";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import TablePagination from "@material-ui/core/TablePagination";
import { MdContentCopy } from "react-icons/md";
import { BsCreditCard } from "react-icons/bs";
import { FaPiggyBank } from "react-icons/fa";
import { BsExclamationCircle } from "react-icons/bs";
import ImportExportIcon from "@material-ui/icons/ImportExport";
import CloseIcon from "@material-ui/icons/Close";
import CancelIcon from "@material-ui/icons/Cancel";
import { CoinContext } from "../../contexts/CoinContext";
import queryString from "query-string";
import { REACT_APP_PROD_URL, PRICES_URL } from "../../services/configs";
import { DriveEtaTwoTone } from "@material-ui/icons";
import AccountBalanceWalletIcon from "@material-ui/icons/AccountBalanceWallet";
import useResizer from "../../services/useResizer";
import CryptoWithdrawDepositCard from "../../components/CryptoWithdrawDepositCard";
import Icon from "../../fontIcons/icon";
import { useSelector } from "react-redux";
import fetcher from "../../api/swr_fetcher";
import { copyTextAndSendToApp } from "../../services/appMethods";
import { useQuery } from "react-query";
import CryptoDepositNetworkTab from "../../components/CryptoDepositNetworkTab";
var QRCode = require("qrcode.react");

export default function CryptoDeposit(props) {
  const classes = useStyles();
  const theme = useTheme();
  const val = queryString.parse(props.location.search);

  const history = useHistory();
  const location = useLocation();

  const token = useSelector((state) => state.trading.TOKEN);
  const [openDialog, setDialog] = useState(false);
  // const [balance, setBalance] = useState(0);
  // const [inOrder, setInOrder] = useState(0);
  // const [coinBalance, setCoinBalance] = useState(null);
  const [depositAddress, setDepositAddress] = useState("");
  const [tagMemo, setTagMemo] = useState(null);
  const [cryptoTrans, setCryptoTrans] = useState(null);
  const [networkTabIndex, setNetworkTabIndex] = useState(0);

  const isMobile = useResizer();

  const [doubleClick, setDoubleClick] = useState(false);
  const coinConfig = useSelector((state) => state.trading.COIN_ICONS);

  const addQueryToRouter = (key, value) => {
    const val = queryString.parse(props.location.search);
    const params = new URLSearchParams({ ...val, [key]: value });
    history.replace({ pathname: location.pathname, search: params.toString() });
  };

  const statusDict = {
    FAILED: "REJECTED",
    IN_PROGRESS: "PENDING",
    AWAITING_ADMIN_ACTION: "PENDING",
    AWAITING_USER_VERIFICATION: "UNVERIFIED",
    APPROVED_BY_ADMIN: "SUCCESS",
    PROCESSED_BY_ADMIN: "SUCCESS",
    REJECTED_BY_ADMIN: "REJECTED",
  };

  const darkStatusColor = {
    SUCCESS: "#C1F4D8",
    FAILED: "#fed9d9",
    IN_PROGRESS: "#fefcd9",
    PENDING: "#fefcd9",
    AWAITING_ADMIN_ACTION: "#fefcd9",
    AWAITING_USER_VERIFICATION: "#fefcd9",
    APPROVED_BY_ADMIN: "#C1F4D8",
    PROCESSED_BY_ADMIN: "#C1F4D8",
    REJECTED_BY_ADMIN: "#fed9d9",
  };

  const darkStatusBackground = {
    SUCCESS: "#20581f",
    FAILED: "#581f1f",
    IN_PROGRESS: "#58571f",
    PENDING: "#58571f",
    AWAITING_ADMIN_ACTION: "#58571f",
    AWAITING_USER_VERIFICATION: "#58571f",
    APPROVED_BY_ADMIN: "#20581f",
    PROCESSED_BY_ADMIN: "#20581f",
    REJECTED_BY_ADMIN: "#581f1f",
  };

  const lightStatusColor = {
    SUCCESS: "#37a609",
    FAILED: "#ff5f5f",
    IN_PROGRESS: "#ffd95f",
    PENDING: "#ffd95f",
    AWAITING_ADMIN_ACTION: "#ffd95f",
    AWAITING_USER_VERIFICATION: "#ffd95f",
    APPROVED_BY_ADMIN: "#37a609",
    PROCESSED_BY_ADMIN: "#37a609",
    REJECTED_BY_ADMIN: "#ff5f5f",
  };

  const { handleClickAlert, refreshBalances, bannedTimeout } =
    useContext(CoinContext);

  const handleDialogOpen = () => {
    setDialog(true);
  };

  const handleDialogClose = () => {
    setDialog(false);
  };

  // for pagination
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(+event.target.value);
    setPage(0);
  };

  useEffect(() => {
    if (token) {
      fetcher(
        `/v1/transfers/crypto?sortBy=createdAt&direction=DESC&page=${
          page + 1
        }&pageSize=${rowsPerPage}&searchId=${val.coin}`
      )
        .then((data) => {
          // console.log("Getting crypto transfers", data);
          if (!data.status) {
            setCryptoTrans(data);
          }
        })
        .catch((err) => {
          // console.error(err)
        });
    }
  }, [val.coin, page, rowsPerPage]);

  // function getDepositAddress() {
  //   if (token) {
  //     fetcher(`/v1/transfers/getAddress/${val.coin}`)
  //       .then((data) => {
  //         // console.log(data);
  //         if (data.depositAddress) {
  //           setDepositAddress(data.depositAddress);
  //           if (data.tagOrMemo) {
  //             setTagMemo(data.tagOrMemo);
  //           }
  //           if (coinBalance.addressPresent === false) {
  //             handleDialogOpen();
  //           }

  //           setDoubleClick(false);
  //         }
  //       })
  //       .catch((err) => {
  //         console.log(err);
  //         if (err.status === 406) {
  //           handleClickAlert(
  //             "error",
  //             "Please complete your KYC to deposit crypto"
  //           );
  //           setDoubleClick(false);
  //         } else {
  //           handleClickAlert("error", "Request failed");
  //           setDoubleClick(false);
  //         }
  //       });

  //     // console.log("Getting deposit address");
  //   }
  // }

  function addZeroes(num) {
    return num.toLocaleString("en", {
      useGrouping: false,
      minimumFractionDigits: 2,
    });
  }

  const networks = [...(coinConfig?.[val.coin]?.depositOptions || [])];

  const handleNetworkTabChange = (e, index) => {
    const networkCoinId =
      coinConfig?.[val.coin]?.depositOptions[index]?.networkCoinId;
    addQueryToRouter("network", networkCoinId);
    setNetworkTabIndex(index);
  };
  const getNetworkContent = (network, coinBalance, coinConfig, isLoading) => {
    // window.dispatchEvent(new CustomEvent("resize"));
    return (
      <CryptoDepositNetworkTab
        coin={val.coin}
        network={network}
        addressPresent={coinBalance?.addressPresent || false}
        minDepositAmount={network.minDeposit || 0}
        networkConfirmation={coinConfig?.confirmations || ""}
        isLoading={isLoading}
      ></CryptoDepositNetworkTab>
    );
  };

  const coinBalanceQuery = useQuery(
    ["coinBalance", val.coin],
    () => fetcher("/v1/balances/" + val.coin).then((res) => res),
    {
      enabled: Boolean(val.coin),
      onSettled: () => {},
    }
  );

  useEffect(() => {
    const networkCoinId = val.network;
    const networkIndex = coinConfig?.[val.coin]?.depositOptions?.findIndex(
      (ele) => ele.networkCoinId == networkCoinId
    );
    if (Boolean(coinConfig?.[val.coin])) {
      if (Boolean(networkCoinId) && networkIndex !== -1) {
        addQueryToRouter(
          "network",
          coinConfig?.[val.coin]?.depositOptions[networkIndex].networkCoinId
        );
        setNetworkTabIndex(networkIndex);
      } else {
        addQueryToRouter(
          "network",
          coinConfig?.[val.coin]?.depositOptions[0].networkCoinId
        );
        setNetworkTabIndex(0);
        // Boolean(coinConfig.depositOptions[networkTabIndex].networkCoinId))
      }

      // window.dispatchEvent(new CustomEvent("resize"));

      // const depositOptions = coinConfig?.[val.coin]?.depositOptions;

      // if (Boolean(depositOptions?.[networkTabIndex]?.networkCoinId)) {
      //   addQueryToRouter(
      //     "network",
      //     depositOptions[networkTabIndex]?.networkCoinId
      //   );
      // }
    }
  }, [coinConfig]);

  const coinBalance = coinBalanceQuery.data?.[0] || {};
  return (
    <div className={classes.container}>
      <h1 className="mb-3">Deposit {val.coin}</h1>
      {/* <hr className="dark:opacity-5 opacity-20" /> */}
      <Divider />
      <div className="font-bold my-1 text-md flex items-center gap-x-2">
        <p
          className=" hover:underline  cursor-pointer"
          onClick={() => {
            history.push(`/wallet/crypto`);
          }}
        >
          Wallet
        </p>{" "}
        {">"}
        <p className="text-pb-primary-100"> Deposit {val.coin}</p>
      </div>
      {/* <hr className="dark:opacity-5 opacity-20 mb-5" /> */}
      <Divider className="mb-5" />

      <div>
        <div className="dark:bg-pb-gray-800 bg-gray-200 p-5 rounded-lg md:w-[700px] w-full mb-5">
          <div className={`${classes.flexContainer} mb-3`}>
            <img
              src={coinConfig?.[val.coin]?.activeIconUrl}
              height="auto"
              width={20}
              className="mr-2"
              alt={val.coin}
            />
            <p
              style={{
                fontSize: "16px",
                fontWeight: "bold",
              }}
            >
              {val.coin} Wallet Balance
            </p>
          </div>
          <div className="font-light">
            <div className={classes.flexContainer} style={{ marginTop: "5px" }}>
              <div className="w-full flex justify-between items-center">
                <p className={`${classes.ptitle} text-sm`}>Available</p>
                <p className={classes.pvalue}>
                  {coinBalance ? Number(coinBalance.availableBalance) : "0"}{" "}
                  {val.coin}
                </p>
              </div>{" "}
            </div>
            <div className={classes.flexContainer}>
              <div
                className="flex whitespace-nowrap justify-between  items-center w-full"
                style={{ marginTop: "5px" }}
              >
                <p className={`${classes.ptitle} text-sm`}>In Order</p>
                <p className={classes.pvalue}>
                  {coinBalance ? Number(coinBalance.inOrderBalance) : "0"}{" "}
                  {val.coin}
                </p>
              </div>
            </div>
            <div
              className={`${classes.flexContainer} justify-between  font-bold`}
              style={{ marginTop: "5px" }}
            >
              <p className={`${classes.ptitle} text-sm`}>Total</p>
              <p className={classes.pvalue}>
                {coinBalance
                  ? Number(coinBalance.availableBalance) +
                    Number(coinBalance.inOrderBalance)
                  : "0"}{" "}
                {val.coin}
              </p>
            </div>
          </div>
        </div>

        <div className="mb-5">
          <h2 className="mb-2">Select Network</h2>
          <div
            className={`dark:bg-pb-gray-800 bg-gray-200 rounded-lg md:w-[700px] w-full `}
            style={{ minWidth: !coinBalance?.addressPresent ? "50%" : "unset" }}
          >
            <Grow in={true}>
              <Tabs
                variant="fullWidth"
                value={networkTabIndex}
                indicatorColor="primary"
                classes={{ indicator: classes.customStyleOnActiveTab }}
                textColor="white"
                onChange={handleNetworkTabChange}
              >
                {networks.map((ele, idx) => {
                  return (
                    <Tab
                      key={ele.networkCoinId}
                      className={`${
                        idx == networkTabIndex && "font-bold"
                      } capitalize text-[16px]`}
                      label={
                        ele.tokenType.length > 0 ? ele.tokenType : val.coin
                      }
                    />
                  );
                })}
              </Tabs>
            </Grow>
            <Divider />
            {Boolean(coinConfig?.[val.coin]) ? (
              <div className="p-5">
                {getNetworkContent(
                  networks[networkTabIndex],
                  coinBalance,
                  coinConfig?.[val.coin],
                  coinBalanceQuery.isLoading
                )}
              </div>
            ) : (
              <div className="flex justify-center my-2 ">
                <CircularProgress color="primary" />
              </div>
            )}
          </div>
        </div>

        <Divider className="mb-5" />
        <div className={`${classes.subContainer} w-full  md:w-[700px] mb-10`}>
          <div className={classes.notice}>
            <div className={classes.flexContainer}>
              <BsExclamationCircle
                style={{ fontSize: "20px", color: "#3AC4AB" }}
              />
              <p
                style={{
                  color: "#3AC4AB",
                  fontWeight: "bold",
                  marginLeft: "10px",
                }}
              >
                Please Note
              </p>
            </div>
            <div style={{ marginTop: "5px" }}>
              <ul style={{ marginTop: 0, marginLeft: "19px" }}>
                <li>
                  Ensure that the network is{" "}
                  <span className="font-bold text-red-500">
                    {networks[networkTabIndex]?.tokenType?.length > 0
                      ? networks[networkTabIndex]?.tokenType
                      : val.coin}
                    . Deposits from any other network will be lost.
                  </span>
                </li>
                <li>
                  The minimum deposit amount for {val.coin} is{" "}
                  {addZeroes(networks[networkTabIndex].minDeposit || 0)}
                </li>
                <li>
                  Coins will be deposited immediately after{" "}
                  {coinConfig?.[val.coin]?.confirmations} network confirmations.
                </li>

                <li>
                  After making a deposit, you can track its progress in the
                  transaction history page.
                </li>
              </ul>
            </div>
          </div>
        </div>
        {/* <Divider /> */}
        <div className={classes.subContainer}>
          <div className={classes.flexContainer}>
            <h2>{val.coin} Transactions</h2>
          </div>
          <div className="mt-2">
            {!Boolean(cryptoTrans?.content?.length) ? (
              <h3 className="font-light text-gray-800 dark:text-gray-400 ">
                No Transactions found
              </h3>
            ) : (
              cryptoTrans?.content?.map((row) => (
                <CryptoWithdrawDepositCard
                  coinConfig={coinConfig[row.currency]}
                  data={row}
                ></CryptoWithdrawDepositCard>
              ))
            )}
          </div>

          <TablePagination
            rowsPerPageOptions={[5, 10, 25, 100]}
            component="div"
            count={cryptoTrans ? cryptoTrans.totalElements : 10}
            rowsPerPage={rowsPerPage}
            page={page}
            onChangePage={handleChangePage}
            onChangeRowsPerPage={handleChangeRowsPerPage}
            labelRowsPerPage="Rows"
          />
        </div>
      </div>

      <Dialog
        fullWidth
        maxWidth="sm"
        open={openDialog}
        onClose={handleDialogClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <div style={{ display: "flex", alignItems: "center" }}>
          <DialogTitle
            style={{ padding: "16px 24px 6px", fontWeight: "bold" }}
            id="alert-dialog-title"
          >
            {val.coin} Wallet Details - QR Code
          </DialogTitle>
          <div className={classes.grow} />
          <IconButton aria-label="close" onClick={handleDialogClose}>
            <CloseIcon />
          </IconButton>
        </div>
        <p
          style={{
            marginTop: 0,
            marginBottom: "10px",
            paddingLeft: "24px",
            fontSize: "14px",
          }}
        >
          Use the Wallet Details below to Deposit {val.coin}
        </p>
        <Divider />

        <div style={{ padding: "14px 24px 14px" }}>
          <DialogTitle
            style={{ fontWeight: "bold", padding: 0, marginBottom: "5px" }}
            id="alert-dialog-title"
          >
            QR Code
          </DialogTitle>
          <QRCode value={depositAddress} />
        </div>

        <Divider />
        <div
          style={{
            display: "flex",
            alignItems: "center",
            marginTop: "15px",
            paddingLeft: "24px",
          }}
        >
          <p style={{ margin: 0, fontSize: "20px" }}>Wallet Address</p>
          <p
            className={classes.link}
            style={{ margin: 0 }}
            onClick={() => {
              navigator.clipboard.writeText(depositAddress);
              copyTextAndSendToApp(depositAddress);

              handleClickAlert("success", "Copied!");
            }}
          >
            Copy
          </p>
        </div>
        <p
          style={{
            marginTop: 0,
            marginBottom: "10px",
            paddingLeft: "24px",
            fontSize: "15px",
            wordWrap: "break-word",
          }}
        >
          {depositAddress}
        </p>

        {tagMemo ? (
          <>
            <div
              style={{
                display: "flex",
                alignItems: "center",
                marginTop: "15px",
                paddingLeft: "24px",
              }}
            >
              <p style={{ margin: 0, fontSize: "20px" }}>Tag or Memo</p>
              <p
                className={classes.link}
                style={{ margin: 0 }}
                onClick={() => {
                  navigator.clipboard.writeText(tagMemo);
                  copyTextAndSendToApp(tagMemo);

                  handleClickAlert("success", "Copied!");
                }}
              >
                Copy
              </p>
            </div>
            <p
              style={{
                marginTop: 0,
                marginBottom: "10px",
                paddingLeft: "24px",
                fontSize: "15px",
              }}
            >
              {tagMemo}
            </p>
          </>
        ) : null}
      </Dialog>
    </div>
  );
}

const useStyles = makeStyles((theme) => ({
  container: {
    flexGrow: 1,
    // [theme.breakpoints.down("sm")]: {
    //   minWidth: "450px",
    //   maxWidth: "450px",
    // },
    [theme.breakpoints.up("md")]: {
      width: "84%",
    },
    marginLeft: "auto",
    marginRight: "auto",
  },
  grow: {
    flexGrow: 1,
  },
  link: {
    fontWeight: "bold",
    color: "#3AC4AB",
    paddingLeft: "10px",
    "&:hover": {
      cursor: "pointer",
      textDecoration: "underline",
    },
  },
  gridContainer: {
    background: theme.palette.type === "dark" ? "#151828" : "white",
    marginTop: "20px",
    paddingTop: "3px",
  },
  subContainer: {
    // marginTop: "15px",
    // marginLeft: "20px",
    paddingBottom: "5px",
    marginRight: "15px",
  },
  flexContainer: {
    display: "flex",
    alignItems: "center",
  },
  ptitle: {
    width: "33%",
    // color: "#9fa1a0",
    fontSize: "17px",
    // marginLeft: "35px",
  },
  pvalue: {
    fontSize: "15px",
    // fontWeight: "bold",
    // color: "#92989B",
  },
  fieldLabel: {
    fontWeight: "bold",
    color: theme.palette.text.primary,
    opacity: "0.5",
    textTransform: "uppercase",
    marginTop: "17px",
    [theme.breakpoints.down("xs")]: {
      fontSize: "0.8rem",
    },
    [theme.breakpoints.up("sm")]: {
      fontSize: "14px",
    },
  },
  notice: {
    border: `1px solid #3AC4AB`,
    backgroundColor: "rgba(86,195,164,0.1)",
    padding: "15px",
    // marginTop: "20px",
    // marginLeft: "15px",
    // marginRight: "15px",
    borderRadius: "8px",
  },
  // container: {
  //   flexGrow: 1,
  //   [theme.breakpoints.down("sm")]: {
  //     minWidth: "450px",
  //     maxWidth: "450px",
  //   },
  // },
  backLink: {
    "&:hover": {
      cursor: "pointer",
      textDecoration: "underline",
    },
    marginBottom: 0,
  },
  headerCell: {
    background: theme.palette.type === "dark" ? "#151827" : "white",
    fontWeight: "bold",
  },
  table: {
    marginTop: "20px",
  },
}));
